import SectorService from '../../services/Sector.js';
import moment from 'moment';

if($('#create-network-component').length){
    var app = new Vue({
        el: '#create-network-component',
        data: {
            defaultImage: 'https://cdn.leadingedgeonly.com/files/platform-images/Mkv33n8JMlxhU413WbL0o7tzA8lp2gsU3xRuQEkp-card.jpg',
            network:{
                name:'',
                strapline:'',
                description:'Please add a description',
                network_status_slug:'draft',
                colour:'#FF6965',
                sector_id:'',
                group_id:'',
                background:"<p>Add a background about your organisation</p>",
                challenge:"<p>Add a full description of your Challenge and what you're looking for.</p>",
                whats_in_it_for_you:'<p>A successful collaboration could mean, for individuals, becoming part of the wider [INSERT COMPANY NAME] group, while for organisations, forming a potential partnership with one of the world’s most iconic brands to co-develop and co-launch the idea to market.</p><p>These are global challenges and [INSERT COMPANY NAME] are willing to collaborate with both individuals/freelancers and other industry participants/universities etc. and solutions can be at any stage of development.</p><p>If you have or are developing solutions, or if you have expertise in the above, please click "Apply" to submit your solution/expertise to the Network.</p>',
                image_location_file:'',
                image_location:'https://cdn.leadingedgeonly.com/files/platform-images/Mkv33n8JMlxhU413WbL0o7tzA8lp2gsU3xRuQEkp-card.jpg',
                header_banner_image_file:'',
                header_banner_image:'https://'+awsUrl+'/25/D3lcLGDuVhF7pvqqxvozuZSwvgMMoT4Pg5ErFSl3.jpg'
            },
            account:{
                accountType:{}
            },
            loadingMessage:'Loading Challenge Creator',
            selectedSector: null,
            loading:true,
            uploaderErrors:[],
            sectors:[],
            anonymousId:anonymousId,
            moment: moment,
            showUploadMedia: false,
            dataImages: [],
            targetId: '',
            imageMedia: false
        },
        methods: {
            getOrganisationLogo() {
                if (this.network.group_id != this.anonymousId) {
                    this.loading = true;
                    axios.get('/api/v1/network/get-organisation-logo/' + this.network.group_id)
                        .then((response) => {
                            if (response.data)
                                this.network.image_location = response.data;
                            this.loading = false;
                        })
                        .catch((error) => {
                            if (error.response) {
                                this.$toasted.error(error.response.data);
                            }
                            this.loading = false;
                        })
                }
            },
            getAccountByUser(){
                axios.get('/api/v1/account/current-user')
                .then((response) =>  {
                    this.account = response.data;
                    this.loading = false;
                })
                .catch((error) =>  {
                    if(error.response){
                        this.$toasted.error(error.response.data);
                    }
                    this.loading = false;
                })
            },
            createNetwork(){
                if(this.validate()){
                    var form =  document.getElementById('editor-form');
                    var formData = new FormData(form);
                    formData = this.appendFields(formData);
                    formData.append('network_status_slug', 'draft');
                    this.loading = true;
                    this.loadingMessage = 'Creating Challenge';

                    if ((!this.network.id && !this.network.image_location_file) || this.imageMedia === true) {
                        formData.append('image_location', this.network.image_location.replace("//" + this.awsUrl + "/", ""));
                        this.imageMedia = false;
                    } else if (this.network.image_location_file) {
                        formData.append('image_location', this.network.image_location_file);
                    }

                    axios.post('/api/v1/network', formData)
                    .then((response) =>  {
                        window.location.replace('/organisation/'+response.data.network_group.slug+'/'+response.data.slug+'/administration/edit');
                    })
                    .catch((error) =>  {
                        this.$toasted.error(error.response.data);
                        this.loading = false;
                    });
                }
            },
            sectorChange(){
                var sectorID = this.network.sector_id;
                var sector = this.sectors.filter(obj => {
                    return obj.id === sectorID;
                });
                this.selectedSector = sector[0];
                if(!this.network.id && !this.network.header_banner_image_file){
                    this.network.header_banner_image = sector[0].image_location;
                }
            },
            getSectorSlug(){
                var sectorID = this.network.sector_id;
                var sector = this.sectors.filter(obj => {
                    return obj.id === sectorID;
                });
                return sector[0].slug;
            },
            previewLogoImage(fileBlob, file) {
                if (fileBlob && file) {
                    this.network.image_location = fileBlob;
                    this.network.image_location_file = file;
                    this.showUploadMedia = false;
                }
            },
            appendFields(formData) {
                formData.append('name', this.network.name);
                formData.append('strapline', this.network.strapline);
                formData.append('description', this.network.description);
                formData.append('background', this.network.background);
                formData.append('challenge', this.network.challenge);
                formData.append('expiry_date', this.network.expiry_date);
                if(this.network.group_id == this.anonymousId){
                    formData.append('anonymous', 1);
                }else{
                    formData.append('anonymous', 0);
                }
                formData.append('whats_in_it_for_you', this.network.whats_in_it_for_you);
                formData.append('sector_id', this.network.sector_id);
                formData.append('group_id', this.network.group_id);
                formData.append('colour', this.network.colour);
                formData.append('header_banner_image_url', this.network.header_banner_image);
                return formData;
            },
            getChallengeURL(){
                var result = this.account.networkGroups.filter(group => {
                    return group.id === this.network.group_id;
                });

                return 'organisation/'+result[0].slug+'/'+this.network.name.replace(/[^A-Z0-9]+/ig, "-").toLowerCase();
            },
            validate(){
                let network = this.network;

                if(!network.name){
                    this.$toasted.error('Your Challenge must have a Title');
                    return false;
                }

                if(!network.strapline){
                    this.$toasted.error('Your Challenge must have a Strapline');
                    return false;
                }

                if(!network.expiry_date){
                    this.$toasted.error('Your Challenge must have a Deadline');
                    return false;
                }

                if(!network.sector_id){
                    this.$toasted.error('Your Challenge must have a Sector');
                    return false;
                }

                if(!network.group_id){
                    this.$toasted.error('Your Challenge must have an Organisation');
                    return false;
                }

                if(this.defaultImage == network.image_location && !network.image_location_file && this.network.group_id != this.anonymousId){
                    this.$toasted.error('Your Challenge must have a Logo');
                    return false;
                }

                return true;
            },
            uploadMedia() {
                this.getUploadedMedia();
                this.targetId = 'image';
                this.showUploadMedia = true;
            },
            getUploadedMedia() {
                axios.get('/api/v1/get-uploaded-media')
                    .then((response) => {
                        if (response.data.hasOwnProperty('uploads')) {
                            this.dataImages = response.data.uploads;
                        }
                    })
                    .catch((error) => {
                        this.errorHandler(error);
                    })
            },
            onSelectImage(data) {
                this.network.image_location = data.src;
                this.imageMedia = true;
                this.showUploadMedia = false;
            },
            selectMethod(result, files) {
                if (result == 'EXTENSION_ERROR') {
                    this.$toasted.error('The selected files contain invalid extensions.');
                    return;
                } else if (result == 'FILE_SIZE_ERROR') {
                    this.$toasted.error('The selected files size exceeded limit.');
                    return;
                }
                if (files && files[0]) {
                    let file = files[0], vm = this, img = new Image();
                    img.onload = function () {
                        if (this.width > 3000 || this.height > 3000) {
                            vm.$toasted.error('The selected image dimensions exceeded limit (3000*3000).');
                        } else {
                            vm.previewLogoImage(img.src, file);
                        }
                    }
                    img.src = URL.createObjectURL(file);
                }
            }
        },
        mounted () {
            SectorService.getSectors().then(data => {
                this.sectors = data;
            });

            $(".tooltipped").tooltip();
            this.getAccountByUser();
        },
        updated: function () {
        },
        components: {
            'SectorService': SectorService
        },
    });
}